import Carousel from 'react-bootstrap/Carousel';
import logo from "../src/logo.png"
import 'bootstrap/dist/css/bootstrap.min.css';
import one from "../src/img/one.png"
import two from "../src/img/two.webp"
function Horrizontalscroll() {
  return (
    <Carousel>
      <Carousel.Item>
      <img
      className="d-block w-100"
      src={one}
      alt="Second slide"
      style={{width:'100%'}}
    />
      </Carousel.Item>

<Carousel.Item>
      <img
      className="d-block w-100"
      src={one}
      alt="Second slide"
      style={{width:'100%'}}
    />
      </Carousel.Item>

<Carousel.Item>
      <img
      className="d-block w-100"
      src={one}
      alt="Second slide"
      style={{width:'100%'}}
    />
       
      </Carousel.Item>
  
    </Carousel>
  );
}

export default Horrizontalscroll;